<script>
  import { serviceStore } from '../stores/serviceStore';
  import { refreshService } from '../utils/serviceAvailability';
  let retrying = false;
  async function retry() { retrying = true; try { await refreshService({ force: true }); } finally { retrying = false; } }
</script>
{#if $serviceStore.phase === 'maintenance' || $serviceStore.phase === 'unavailable' || $serviceStore.notice?.message || $serviceStore.notice?.starts_at || $serviceStore.notice?.block_new_requests}
  <aside class="notice" class:blocked={$serviceStore.blocksNewRequests} role="status">
    <strong>{$serviceStore.phase === 'maintenance' ? '서비스 점검 중' : $serviceStore.phase === 'unavailable' ? '서버 연결을 확인해 주세요' : '서비스 안내'}</strong>
    <span>{$serviceStore.notice?.message || '잠시 후 다시 연결해 주세요. 준비한 사진과 편집 옵션은 유지됩니다.'}</span>
    {#if $serviceStore.notice?.starts_at && $serviceStore.phase !== 'maintenance'}<span>점검 시작: {new Date($serviceStore.notice.starts_at).toLocaleString()}</span>{/if}
    {#if $serviceStore.notice?.expected_end_at}<span>종료 예정: {new Date($serviceStore.notice.expected_end_at).toLocaleString()}</span>{/if}
    <button type="button" on:click={retry} disabled={retrying}>{retrying ? '확인 중...' : '다시 확인'}</button>
  </aside>
{/if}
<style>
  .notice { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; padding: 14px 24px; background: #fff1da; color: #674414; border-bottom: 1px solid #e7ceac; }
  .blocked { background: #ffe4df; color: #8d321f; } span { line-height: 1.6; }
  button { color: inherit; background: transparent; border: 1px solid currentColor; border-radius: 8px; padding: 6px 12px; cursor: pointer; margin-left: auto; }
</style>
